module.exports = __webpack_public_path__ + "media/images/ticbalionlineshop-0491bfd5298c12eea34c944ea5d4e16e.png";